import {
  Box,
  RingWarranty,
  RingWithArrows,
  Wallet,
} from '@components/yadav/icons'

export const ydBenefitsAssets = [
  {
    icon: () => <RingWarranty width="37" height="40" />,
    title: 'Lifetime Upgrades & Warranty',
    text: 'Only pay the difference in price.',
  },
  {
    icon: () => <Wallet width="40" height="40" />,
    title: '30 Day Money Back Guarantee',
    text: 'You can shop with confidence.',
  },
  {
    icon: () => <RingWithArrows width="72" height="40" />,
    title: '60 Days Unlimited Resizing',
    text: 'Need a different size? Just let us know!',
  },
  {
    icon: () => <Box width="40" height="40" />,
    title: 'Free Overnight Shipping & Return',
    text: 'Free domestic shipping both ways!',
  },
]
